import { DealType } from "@/enums/dealType";
import { Filter } from "@/types/SearchFilter.types";

export const initialFilterValue = (
  dealType: DealType,
  defaultRegions: string[] = [],
): Filter => ({
  dealType,
  page: 1,
  limit: 12,
  propertyType: [],
  objectType: [],
  totalPriceMin: undefined,
  totalPriceMax: undefined,
  pricePerSqMMin: undefined,
  pricePerSqMMax: undefined,
  areaMin: undefined,
  areaMax: undefined,
  currency: undefined,
  priceCurrency: undefined,
  titleOrDescription: undefined,
  customId: undefined,
  region: defaultRegions,
  city: [],
  district: [],
  microdistrict: [],
  street: [],
  metroStation: [],
  areaLandMin: undefined,
  areaLandMax: undefined,
  ceilingHeightMin: undefined,
  ceilingHeightMax: undefined,
  propertyClass: [],
  rooms: [],
  bedrooms: [],
  bathrooms: [],
  frame: [],
  amenities: [],
  comfort: [],
  appliances: [],
  multimedia: [],
  communications: [],
  infrastructure: [],
  landscape: [],
  pets: [],
  rentalOptions: [],
  constructionStatus: [],
  constructionCompletionDate: [],
  numberOfApartments: [],
  numberOfBuildings: [],
  availabilityOfInstallments: [],
  walls: [],
  condition: [],
  repair: [],
  parking: [],
  numberOfFloors: [],
  additionally: [],
  developerName: undefined,
  developerLink: undefined,
  projectName: undefined,
  projectLink: undefined,
  exclusiveType: [],
  isGoldenVisaEligible: undefined,
});
